declare global {
  interface Window {
    dataLayer: any;
  }
}

export type GraphItem = {
  color: string;
  percent: number;
};
export interface MapLegendItem extends GraphItem {
  text: string;
}

export type Track = {
  loanAmount: string;
  productCode: string;
  trackName: string;
  period: string;
  scheduleId: string;
  interestRate: string;
};

export interface MixesValues {
  mortgageSum: string;
  period: number;
}

export interface Values {
  tracks: Track[];
}

export enum SIGN {
  ILS = "₪",
  PERCENT = "%",
}

export type AmountType = {
  value: string;
  sign: SIGN;
};

// export enum TrackName {
//   TREASURY = "אוצר",
//   ANCHOR = "משתנה לא צמודה כל שנה, על בסיס מק״מ",
//   UNLINKED_CHANGED_EVERY_5_YEAR = "משתנה לא צמודה כל 5 שנים, על בסיס אג״ח ממשלתי",
//   FIXED = "ריבית צמודה קבועה",
//   EURO = "ריבית משתנה על בסיס אירו",
//   DOLLAR = "ריבית משתנה על בסיס דולר ארצות הברית",
//   PRIME = "פריים",
//   NON_LINKED_FIXED = "ריבית קבועה לא צמודה",

// UNLINKED_CHANGED_EVERY_10_YEAR = "משתנה לא צמודה כל 10 שנים, על בסיס אג״ח ממשלתי",
// UNLINKED_CHANGED_EVERY_7_YEAR ="משתנה לא צמודה כל 7 שנים, על בסיס אג״ח ממשלתי",

//   LINKED_CHANGED_EVERY_5_YEAR = "משתנה צמודה כל 5 שנים, על בסיס אג״ח ממשלתי",
//   LINKED_CHANGED_EVERY_2_YEAR = "משתנה צמודה כל 2 שנים, על בסיס אג״ח ממשלתי",
//   LINKED_CHANGED_EVERY_YEAR = "משתנה צמודה כל שנה, על בסיס אג״ח ממשלתי",
// }

export enum TrackCode {
  NON_LINKED_FIXED = 1,
  FIXED = 2,
  PRIME = 3,
  UNLINKED_CHANGED_EVERY_10_YEAR = 4,
  UNLINKED_CHANGED_EVERY_7_YEAR = 5,
  UNLINKED_CHANGED_EVERY_5_YEAR = 6,
  LINKED_CHANGED_EVERY_5_YEAR = 7,
  LINKED_CHANGED_EVERY_2_YEAR = 8,
  LINKED_CHANGED_EVERY_YEAR = 9,
  ANCHOR = 10,
  EURO = 11,
  DOLLAR = 12,
  UNLINKED_CHANGED_EVERY_2_5_YEAR = 13,
  TREASURY = "none",
}

export const MAP: Record<TrackCode, string> = {
  [TrackCode.TREASURY]: "bg-grDarkPurple",
  [TrackCode.ANCHOR]: "bg-grDarkBlue",
  [TrackCode.UNLINKED_CHANGED_EVERY_5_YEAR]: "bg-grRed",
  [TrackCode.FIXED]: "bg-grPink",
  [TrackCode.EURO]: "bg-grDarkGreen",
  [TrackCode.DOLLAR]: "bg-grTurquoise",
  [TrackCode.PRIME]: "bg-grOrange",
  [TrackCode.UNLINKED_CHANGED_EVERY_10_YEAR]: "bg-grBordeaux",
  [TrackCode.UNLINKED_CHANGED_EVERY_7_YEAR]: "bg-grPurple",
  [TrackCode.NON_LINKED_FIXED]: "bg-grBlue",
  [TrackCode.LINKED_CHANGED_EVERY_5_YEAR]: "bg-grGreen",
  [TrackCode.LINKED_CHANGED_EVERY_2_YEAR]: "bg-grYellow",
  [TrackCode.LINKED_CHANGED_EVERY_YEAR]: "bg-grPurple",
  [TrackCode.UNLINKED_CHANGED_EVERY_2_5_YEAR]: "bg-grolive",
};

export interface Payload {
  ProcessType: string;
  ProcessParam1: string;
  ProcessParam2: string;
  ProcessParam3: string;
  ProcessParam4: string;
  ProcessParam5: string;
  ProcessParam6: string;
}
